import React, { Component } from "react";
import Context from "../../../context/Context";
import Topic from "../../../context/Topic";
import TextareaAutosize from 'react-textarea-autosize';
import { ButtonGroup } from "../../styles/Common/sort";
import * as CrudComment from "../../base/transaction/comment";
import * as commentReplyUtil from "./commentReplyUtil";
import  { ThemeColorButton } from "../../styles/commentsStyles";

export default class EditComment extends Component {

    constructor(props){
        super(props);
        this.state={
            inputChange : this.props.comment,
            emptyComment : false,
            isCalloutClicked : false
        }
    }

    handleCancel=()=>{
        this.props.closeEdit();
    }

    handleInputChange =(evt)=> {
        this.setState({
            inputChange : evt.target.value
        },function(){
            if(!this.state.inputChange) {
                this.setState({
                    emptyComment : true
                })
            }else{
                this.setState({
                    emptyComment : false
                })
            }
        })
    }

    render(){
        const i18n = Context.instance.i18n;
        let showError;
        if(this.state.emptyComment) showError = i18n.spaceplanner.comments.emptyComment;
        return(
            <div style={{display:"flex", flexDirection: "column", alignItems: "flex-end", margin: "0 0.5rem", paddingBottom:"0.5rem"}}>
                <TextareaAutosize 
                    autoFocus
                    style={{width: "97%", borderColor:"#cacaca", padding:"5px", fontFamily: "sans-serif", color:"#323232",}}
                    minRows={2} 
                    value={Context.sanitizeHtml(this.state.inputChange)}
                    onChange={this.handleInputChange}
                    />
                <div style={{fontSize: "0.8125rem", color: "#808080"}}>{showError}</div>
                <ButtonGroup>
                    <ThemeColorButton transparent extraSmall onClick={this.saveComment}>{i18n.general.save}</ThemeColorButton>
                    <ThemeColorButton transparent extraSmall onClick={this.handleCancel}>{i18n.general.cancel}</ThemeColorButton>
                </ButtonGroup>
            </div>
        )
    }

    saveComment=()=>{
        this.setState({
            inputChange : this.state.inputChange
        },
        function(){
            if(!this.state.inputChange){
                this.setState({
                    emptyComment : true
                })
            }else{
                const commentId = this.props.commentId;
                const url = commentReplyUtil.getCommentUrl();
                const obj = {
                    updatedComment : this.state.inputChange,
                    commentId : commentId
                };
                CrudComment.editComment(obj, url).then(()=> {
                    this.props.closeEdit();
                    Topic.publish(Topic.LoadComments);
                })
                .catch(error => {
                    console.error(error);
                    Topic.publishErrorUpdatingData(error.message);
                })
            }
        })
    }
}